/* eslint-disable camelcase */
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter } from '../../../../utils/formatting';
import DiscountFormatter from '../../DiscountFormatter';

import ForeignCurrency from './ForeignCurrency';

const Cash = ({
  tenderInfo, timezone
}) => {
  const {
    locale: { storeCurrency, storeLocale, momentFormat }, RL_ApprovalNumber, RL_ApprovalDateTime, RL_CashRounding, RL_Change, RL_TenderVoid, UI_Cash, RL_IdentificationNumber
  } = useSelector((state) => state);
  // Korea Integrated cash condition
  const koreaIntegratedKoreaCash = storeLocale === 'ko-KR' && tenderInfo.Tender?.VendorIntegratedPayment && tenderInfo.Tender?.TypeCode === 'Sale';
  const foreignCurrency = (tenderInfo.Tender?.TypeCode === 'Sale' && tenderInfo.Tender?.ForeignCurrency) ? tenderInfo.Tender.ForeignCurrency : null;
  // Korea Non-Integrated cash condition
  const nonIntegratedKoreaCash = storeLocale === 'ko-KR' && !tenderInfo.Tender?.VendorIntegratedPayment && tenderInfo.Tender?.TypeCode === 'Sale';
  // Global cash condition
  const nonKoreaCash = storeLocale !== 'ko-KR' && tenderInfo.Tender?.TypeCode === 'Sale';
  const cashChange = tenderInfo.TenderChange?.TypeCode === 'Refund' || tenderInfo.Tender?.TypeCode === 'Refund';
  // Korea Non-Integrated cash change condition
  const nonIntegratedKoreaCashChange = storeLocale === 'ko-KR' && !tenderInfo.Tender?.VendorIntegratedPayment && cashChange;
  // Global cash change condition
  const nonKoreaCashChange = storeLocale !== 'ko-KR' && cashChange;
  const isCashRefund = tenderInfo.Tender?.TypeCode === 'Refund' && tenderInfo.Tender?.TenderType === 'Cash';
  const isVoidTender = tenderInfo.VoidFlag;
  const isCashRounding = ['CashRoundingUp', 'CashRoundingDown'].includes(tenderInfo?.TenderChange?.TypeCode);

  function CashAmount() {
    if (foreignCurrency) {
      return <ForeignCurrency foreignCurrency={foreignCurrency} tenderInfo={tenderInfo} />;
    } else if (koreaIntegratedKoreaCash || nonIntegratedKoreaCash || nonKoreaCash) {
      return (
        <article className="justify-between">
          <p>{UI_Cash}</p>
          <p>{currencyFormatter(
            storeLocale,
            storeCurrency,
            tenderInfo.Tender?.Amount?.Amount,
          )}
          </p>
        </article>
      );
    } else return null;
  }

  return (
    <>
      {(koreaIntegratedKoreaCash) && (
      <>
        <article className="justify-between">
          <p>{RL_IdentificationNumber}</p>
          <p>{tenderInfo.Tender?.CustomerIdentificationNumber}</p>
        </article>
        {tenderInfo.Tender?.Authorizations?.map((tender, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <section key={i}>
            <article className="justify-between">
              <p>{RL_ApprovalNumber}</p>
              <p>{tender.AuthorizationCode}</p>
            </article>
            <article className="justify-between">
              <p>{RL_ApprovalDateTime}</p>
              <p>{moment(tender.AuthorizationDateTime).tz(timezone).format(`${momentFormat} HH:mm`)}</p>
            </article>
          </section>
        ))}
      </>
      )}
      <CashAmount />
      {isCashRounding && (
        <article className="justify-between">
          <p>{RL_CashRounding}</p>
          <p>
            {currencyFormatter(
                storeLocale,
                storeCurrency,
                tenderInfo?.TenderChange?.Amount?.Amount
              )}
          </p>
        </article>
      )}
      {(nonIntegratedKoreaCashChange || nonKoreaCashChange) && (
      <>
        {isVoidTender && (
        <article className="justify-between">
          <p>&lt;{RL_TenderVoid}&gt;</p>
        </article>
        )}
        <article className="justify-between">
          <p>{isCashRefund ? `${UI_Cash}` : `${UI_Cash} ${RL_Change}`}</p>
          <p>
            <DiscountFormatter isNegative={isCashRefund} storeLocale={storeLocale}>
              {currencyFormatter(
                storeLocale,
                storeCurrency,
                  tenderInfo.TenderChange?.TypeCode === 'Refund' ? tenderInfo.TenderChange?.Amount?.Amount : tenderInfo.Tender?.Amount?.Amount, /* TODO */
              )}
            </DiscountFormatter>
          </p>
        </article>
      </>
      )}
      <br /><br />
    </>
  );
};

Cash.defaultProps = {
  tenderInfo: {},
  timezone: '',
};

Cash.propTypes = {
  tenderInfo: PropTypes.shape(),
  timezone: PropTypes.string,
};

export default Cash;
